<template>
    <div class="order_detial no-trans" v-loading="loading">
        <div class="order_titles">评价</div>
        <div class="order_derial_box">
             
             
            <div class="order_item">
                <div class="item_titles">
                    <div class="order_lefts">
                        <div class="order_time">{{ order_detial.created_at }} </div>
                        <div class="order_no">订单号：{{ order_detial.order_sn }}</div>
                    </div>
                </div>
                <div class="order_info_shop">
                    <div class="items_top">
                        <div class="user_imgs">
                            <img src="@/assets/img/index/comments_case/user_img.png" alt="" v-if="!lawyer.avatar">
                            <img :src="lawyer.avatar" alt="" v-if="lawyer.avatar">
                        </div>
                        <div class="user_info">
                            <div class="names">{{ lawyer.lawyer.name }}</div>
                            <div class="times">{{ lawyer.created_at }}</div>
                        </div>
                        
                    </div>
                   
                </div>
            </div>
            <div class="pj_box">
                <div class="pj_tops">
                    <div class="texts1">总体评价</div>
                    <div class="pj_nums">
                        <img src="@/assets/img/user_info/user_order/xx_1.png" alt="" v-for="(item,index) in 5" v-if="(index+1)<=nums" @click="handle_nums(index)">
                        <img src="@/assets/img/user_info/user_order/xx_2.png" alt="" v-for="(item,index) in 5" v-if="(index+1)>nums" @click="handle_nums(index)">
                    </div>
                </div>
                <div class="pj_tops">
                    <div class="texts1">标签</div>
                    <div class="pj_tage">
                        <!-- {{ law_tags }} -->
                        <div class="tages" :class="{tages_ac:item.show}" v-for="(item,index) in law_tags" :key="index" @click="item.show=!item.show">{{ item.title }}</div>
                    </div>
                </div>
                <div class="pj_boms">
                    <textarea name="" id="" placeholder="请输入…" v-model="content"></textarea>
                </div>
            </div>
            <div class="order_btns">
                <div class="btns1" @click="handle_end">发表评价</div>
              
            </div>
        </div>

    </div>
</template>
<script>
import { mapState } from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            
            nums:1,
            order_detial:{},
            lawyer:{
                lawyer:{},
            },
            content:'',
            setting:{},
            law_tags:[],
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_order_detial()
        this.get_setting()
    },
    methods: {
        get_order_detial(){
            this.loading = true
            this.$api("caseDetail", {
               id:this.$route.query.order_id
			}, "get").then((res) => {
                this.loading = false
                console.log('我的点评详情',res)
                if (res.code == 1) {
                   this.order_detial=res.data
                   res.data.lawyer_comment.forEach((e)=>{
                        if(e.lawyer_id==this.$route.query.la_id){
                            this.lawyer=e
                        }
                   })
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_setting(){
            this.loading=true
            this.$api("setting", {
				 
			}, "get").then((res) => {
                this.loading = false
                console.log('配置',res)
                if (res.code == 1) {
                    this.setting=res.data
                    res.data.law_tags.forEach((e)=>{
                        this.law_tags.push({
                            title:e,
                            show:false
                        })
                    })
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_nums(index){
            console.log('星星',index+1)
            this.nums=index+1
        },
        handle_end(){
            let tages=[]
            this.law_tags.forEach((e)=>{
                if(e.show){
                    tages.push(e.title)
                }
            })
            if(tages.length==0){
                alertErr('请选择标标签')
                return
            }
            if(!this.content){
                alertErr('请输入评论内容')
                return
            }
           
            this.loading = true
            this.$api("createComments", {
                lawyer_id:this.$route.query.la_id,
                tag:tages.join(','),
                star:this.nums,
                content:this.content,


			}, "post").then((res) => {
                this.loading = false
                console.log('我的点评详情',res)
                if (res.code == 1) {
                    alertSucc('发表成功')
                    this.$router.back()
                } else {
                    alertErr(res.msg)
                }
            });
        },
        


    },

}
</script>
<style scoped lang="less">
.order_detial {
    .order_titles {
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }

    .order_derial_box {
        margin-top: 24px;
        padding: 24px;
        background: #FFFFFF;

     

        .order_item {
            // width: 1132px;
            // min-height: 260px;
            margin-top: 24px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E5E5;

            .item_titles {
                // width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;

                .order_lefts {
                    display: flex;
                    align-items: center;

                    .order_time {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                        margin-right: 20px;
                    }

                    .order_no {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                    }
                }

                .order_rights {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }

            .order_info_shop {
                width: 100%;
                background: #FFFFFF;
                border-radius: 3px 3px 3px 3px;
                border: 1px solid #D7DEE5;
                padding: 21px 18px 30px 25px;
                .items_top{
                    display: flex;
                    .user_imgs{
                        width: 64px;
                        height: 64px;
                        img{
                            width: 64px;
                            height: 64px;
                            border-radius: 50%;
                        }
                    }
                    .user_info{
                        width: 200px;
                        padding:  8px 0;
                        padding-left: 24px;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: space-between;
                        .names{
                            width: 100%;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;

                        }
                        .times{
                            width: 100%;
                            
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #666666;

                        }
                    }
                    
                }
                
            }
        }
        .pj_box{
            width: 1132px;
            height: 192px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E5E5;
            margin-top: 24px;
            .pj_tops{
                width: 1132px;
                min-height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                padding: 0 24px;
                display: flex;
                align-items: center;
                .texts1{
                    width: 80px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;

                }
                .pj_nums{
                    padding-left: 20px;
                    img{
                        width: 21px;
                        margin-right: 16px;
                        cursor: pointer;
                    }
                }
                .pj_tage{
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    .tages{
                        padding: 0 13px;
                        height: 32px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        border: 1px solid #D7D7D7;
                        font-weight: 400;
                        font-size: 12px;
                        color: #999999;
                        text-align: center;
                        cursor: pointer;
                        line-height: 32px;
                        margin-right: 10px;
                        &:hover{
                            color: #fff;
                            background-color:#377CFD ;
                        }
                    }
                    .tages_ac{
                        color: #fff;
                            background-color:#377CFD ;
                    }
                }

            }
            .pj_boms{
                padding: 16px 24px;
                textarea{
                    width: 100%;
                    height: 120px;
                }
            }
        }
        .order_btns{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 32px;
            .btns1{
                width: 320px;
                height: 48px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                text-align: center;
                line-height: 48px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
            }
          
        }

    }



}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .order_detial.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .order_detial.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .order_detial.no-trans .order_derial_box {
        margin-top: 16px;
        padding: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item {
        margin-top: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles {
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        min-height: 44px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles .order_lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles .order_lefts .order_time {
        font-size: 14px;
        margin-right: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles .order_lefts .order_no {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles .order_rights {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop {
        border-radius: 3px 3px 3px 3px;
        padding: 16px 16px 16px 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .items_top {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .items_top .user_imgs {
        width: 64px;
        height: 64px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .items_top .user_imgs img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .items_top .user_info {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding: 8px 0;
        padding-left: 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .items_top .user_info .names {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .items_top .user_info .times {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box .pj_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops .texts1 {
        width: 80px;
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops .pj_nums {
        padding-left: 16px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops .pj_nums img {
        width: 21px;
        margin-right: 16px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops .pj_tage {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops .pj_tage .tages {
        padding: 0 13px;
        height: 32px;
        border-radius: 0px 0px 0px 0px;
        font-size: 14px;
        line-height: 32px;
        margin-right: 10px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_boms {
        padding: 16px 16px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_boms textarea {
        min-height: 0;
        height: auto;
    }
    .order_detial.no-trans .order_derial_box .order_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_btns .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
